import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { returnCategories } from './../../scripts';
import { fonts } from './../../styles/theme.json';
import { returnOpacity } from './../../scripts';

class MasonryItemCaption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemStyle: {
        opacity: 0
      },
      gradAlpha: {
        opacity: returnOpacity(this.props.itemData.project_caption.gradient_opacity)
      }
    };
  }

  handleImageLoaded() {
    setTimeout(() => {
      this.setState({
        itemStyle: {
          opacity: 1
        }
      });
    }, 250);
  }

  render() {
    const Caption = (props) => {
      return (
        <div className="mg__caption">
          <span className="primary" dangerouslySetInnerHTML={{__html:props.captionData.headline}} />
          {(props.captionData.description) && <span className="separator">/</span>}
          <span className="secondary" dangerouslySetInnerHTML={{ __html:props.captionData.description}} />
          <style jsx>{`
            .mg__caption {
              width: 100%;
              padding-left: 1em;
              padding-bottom: 1em;
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              display: flex;
              flex-direction: row;
            }
            .separator,
            .primary,
            .sep,
            .secondary {
              color: #fff;
              font-size: ${fonts.tiny};
              letter-spacing: ${fonts.caption_spacing};
              font-family: ${fonts.mallory};
              text-transform: uppercase;
              margin: 0;
            }
            .primary,
            .sep {
              font-family: ${fonts.mallory};
              padding-right: .15rem;
              font-weight: bold;
            }
            .secondary {
              font-family: ${fonts.mallory};
              font-weight: normal;
            }
          `}</style>
        </div>
      );
    };

    return (
      <li className={'mg-li'}>
        <div className={'mg-item ' + returnCategories(this.props.itemData.nav_categories)} style={this.state.itemStyle}>
          <Link to={'/' + this.props.itemData.link.postType + '/' + this.props.itemData.link.slug} className="mg-item__link">
            <div className='mg__caption-wrapper'>
              <Caption captionData={this.props.itemData.project_caption} />
            </div>
            <div className="bg-gradient" style={this.state.gradAlpha}/>
            <img className="mg--image" src={this.props.itemData.image.small} onLoad={this.handleImageLoaded.bind(this)}/>
          </Link>
        </div>
      </li>
    );
  }
}

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(MasonryItemCaption);



// WEBPACK FOOTER //
// ./src/components/filter-pages/MasonryItemCaption.js